import React from 'react';
import styles from './VideoBoard.css';
import Svg from '../../components/InlineSVG';
import range from 'lodash/range';
import { gcpURL } from '../../lib/utils';

const IconTV = `${gcpURL}/static/ig-tv@2x.png`;

const VideoBoard = ({children, text}) => {
  return (
    <div className={styles.videoBoard}>
      <div className={styles.videoBox}>
        <div className={styles.children}>
          {children}
        </div>
      </div>
      <img className={styles.tvSvg} src={IconTV} alt="TV body"/>
    </div>
  );
};

export default VideoBoard;



// WEBPACK FOOTER //
// ./src/components/VideoBoard/index.js